import React from 'react';
import { Fade } from 'react-awesome-reveal';

const FadeWrapper = ({ children, ...props }) => {
  return (
    <Fade triggerOnce direction="up" duration={600} {...props}>
      {children}
    </Fade>
  );
};

export default FadeWrapper;

